import { render, staticRenderFns } from "./ot.vue?vue&type=template&id=6d06db8e&scoped=true&"
import script from "./ot.vue?vue&type=script&lang=js&"
export * from "./ot.vue?vue&type=script&lang=js&"
import style0 from "./ot.vue?vue&type=style&index=0&id=6d06db8e&lang=scss&scoped=true&"
import style1 from "./ot.vue?vue&type=style&index=1&id=6d06db8e&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d06db8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d06db8e')) {
      api.createRecord('6d06db8e', component.options)
    } else {
      api.reload('6d06db8e', component.options)
    }
    module.hot.accept("./ot.vue?vue&type=template&id=6d06db8e&scoped=true&", function () {
      api.rerender('6d06db8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/leaves/ot.vue"
export default component.exports